import React, {useEffect, useState} from 'react';
import {useStyles} from "./TextInput.style";
import {useCommonStyles} from "../common/CommonStyles.style";
import TextInputType from "./TextInputType";
import TextInputProperties from "./TextInputProperties";
import clsx from "clsx";


const TextInput: React.FC<TextInputProperties> = ({
                                                      type = TextInputType.TEXT,
                                                      error,
                                                      label,
                                                      value = '',
                                                      maxLength,
                                                      placeholder = '',
                                                      helpText,
                                                      onChange,
                                                      disabled = false,
                                                      startIcon: StartIcon,
                                                      endIcon: EndIcon,
                                                      fullWidth = false,
                                                      className = '',
                                                      onFocus = () => {
                                                      },
                                                      onBlur = () => {
                                                      },
                                                      onKeyPress = () => {
                                                      }
                                                  }: TextInputProperties) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const [currentValue, setCurrentValue] = useState(value);

    const containerClasses = clsx(
        classes.text_input_container,
        className,
        fullWidth && commonClasses.fullWidth,
        error && classes.input_container_error);

    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    const onValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setCurrentValue(e.target.value);
        onChange(e);
    }
    return (
        <div className={containerClasses}>
            <div className={classes.label}>{label}</div>
            <div className={classes.input_container}>
                {StartIcon &&
                <div className={classes.start_icon_container}>
                    <StartIcon/>
                </div>}
                <input
                    type={type}
                    value={currentValue}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    className={classes.input}
                    onKeyPress={(event => onKeyPress(event.key))}
                    onChange={onValueChange}
                    disabled={disabled}
                    maxLength={maxLength}
                />
                {EndIcon &&
                <div className={classes.end_icon_container}>
                    <EndIcon/>
                </div>}
            </div>
            <div className={clsx(classes.text_hint, error && classes.error)}>{error || helpText}</div>
        </div>
    )
}
export default TextInput;